export const PLATFORMS = {
  INSTAGRAM: "instagram",
  TIKTOK: "tiktok",
  TWITTER: "twitter",
  YOUTUBE: "youtube",
  REDDIT: "reddit",
  FACEBOOK: "facebook",
  LINKEDIN: "linkedin",
  PINTEREST: "pinterest",
  SUBSTACK: "substack",
  WEB: "web",
  UPLOAD: "upload",
} as const;

export type Platform = (typeof PLATFORMS)[keyof typeof PLATFORMS];
